import script from "./HrSideSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSideSheet.vue?vue&type=script&setup=true&lang=js"

import "./HrSideSheet.vue?vue&type=style&index=0&id=3ebb94d9&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
